<template>
  <v-container fluid>
    <v-layout row justify-space-between>
      <v-flex xs6>
        <v-select :items="unit" v-model="unitFrom.text" label="Select" single-line bottom></v-select>
      </v-flex>
      <v-flex xs6 offset-xs1>
        <v-select :items="unit" v-model="unitTo.text" label="Select" single-line bottom></v-select>
      </v-flex>
    </v-layout>
    <v-layout row grid-list-md>
      <v-flex lg6 md6>
        <v-text-field label="From" v-model="valueFrom" type="number"></v-text-field>
      </v-flex>
      <v-flex lg5 md6 offset-xs1>
        <v-text-field :label="valueTo ? valueTo : 'To'" disabled type="number"></v-text-field>
      </v-flex>
      <v-flex lg1 md12>
        <v-btn color="primary" @click="copy()">Copy</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex lg6>
        <v-switch label="Exponent" v-model="exponent" color="primary"></v-switch>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex lg2 sm2 xs12>
        <v-switch label="Round number" v-model="round" color="primary"></v-switch>
      </v-flex>
      <v-flex lg3 sm3 xs12 v-if="round">
        <v-text-field
          type="number"
          :label="`Rounding number to ${roundNumber} decimal places`"
          v-model="roundNumber"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-snackbar :timeout="3000" v-model="snackbar" :bottom="true" color="primary">
      Copy successful
      <v-btn flat color="red" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import temperature from '../utils/temperature'

export default {
  props: ['type'],
  data() {
    return {
      unitFrom: {
        text: this.$store.state.unit[0].text,
        val: 1
      },
      unitTo: {
        text: this.$store.state.unit[0].text,
        val: 1
      },
      valueFrom: 0,
      valueTo: 0,
      snackbar: false,
      exponent: false,
      round: false,
      roundNumber: 0
    }
  },
  computed: {
    unit() {
      return this.$store.state.unit
    }
  },
  watch: {
    $data: {
      handler: function(val, oldVal) {
        this.unitFrom.val = this.$store.getters.getUnitByText(
          this.unitFrom.text
        ).val
        this.unitTo.val = this.$store.getters.getUnitByText(
          this.unitTo.text
        ).val
        if (!isNaN(this.valueFrom)) {
          this.valueTo = this.convert()
        }
      },
      deep: true
    }
  },
  methods: {
    convert() {
      let val = (this.unitTo.val * this.valueFrom) / this.unitFrom.val
      if (this.type === 'temperature') {
        const valueTo = temperature(
          this.unitFrom.text,
          this.unitTo.text,
          this.valueFrom
        )
        val = valueTo
      }
      if (!this.exponent) {
        val = this.noExponents(val)
      }
      if (this.round) {
        val = parseFloat(val)
        val = val.toFixed(this.roundNumber)
      }
      return val.toString()
    },
    copy() {
      this.snackbar = true
      const data = this.valueTo
      let input = document.createElement('input')
      input.value = data
      input.id = 'inpCopy'
      document.body.appendChild(input)
      let text = document.getElementById('inpCopy')
      text.select()
      document.execCommand('copy')
      text.remove()
    },
    noExponents(number) {
      let data = String(number).split(/[eE]/)
      if (data.length == 1) return data[0]

      let z = '',
        sign = number < 0 ? '-' : '',
        str = data[0].replace('.', ''),
        mag = Number(data[1]) + 1

      if (mag < 0) {
        z = sign + '0.'
        while (mag++) z += '0'
        return z + str.replace(/^\-/, '')
      }
      mag -= str.length
      while (mag--) z += '0'
      return str + z
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ConvertBox.vue?7dc25fec